package Pages

import StyleSheets.DefaultStyle
import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.Style

@Composable
fun smartMemoPage() {
    Style(DefaultStyle)
}